import type { FC } from 'react';
import { Box, Typography } from '@mui/material';

import ComparisonPill from 'src/components/dashboard/DashboardPage/components/ComparisonPill/ComparisonPill';
import { getRelativeValue } from 'src/components/dashboard/DashboardPage/helper';

import BarSegment from './BarSegment';

import { styles } from './index.styles';

interface StackedBarProps {
  bar: {
    label: string;
    stacks: Array<{ stackLabel: string; value: number }>;
    comparisonValue?: string | number;
  };
  stackLabels: Array<{ name: string; color: string }>;
  totalValue: number;
  calculatedMaxValue: number;
  condensed?: boolean;
}

const StackedBar: FC<StackedBarProps> = ({
  bar,
  stackLabels,
  totalValue,
  calculatedMaxValue,
  condensed,
}) => (
  <Box sx={{ flexShrink: condensed ? 1 : 0, ...styles.barContainer }}>
    <Box sx={styles.barData}>
      {bar.comparisonValue !== undefined && (
        <ComparisonPill
          value={`${bar.comparisonValue}%`}
          sx={styles.comparisonPill}
        />
      )}
      {bar.stacks.map((stack) => {
        const stackLabelConfig = stackLabels.find(
          (label) => label.name === stack.stackLabel,
        );
        if (!stackLabelConfig) return null;
        const percentage = getRelativeValue(stack.value, totalValue, 0);

        if (!percentage) return null;
        return (
          <BarSegment
            key={stack.stackLabel}
            type="vertical"
            relativeSize={getRelativeValue(stack.value, calculatedMaxValue)}
            borderPosition="Left"
            color={`${stackLabelConfig.color}1A`}
            borderColor={stackLabelConfig.color}
            // Only render labels that can be rendered without overlapping adjacent segments
            label={percentage >= 4 ? `${percentage}%` : undefined}
            borderWidth={4}
            toolTip={`n=${stack.value.toString()}`}
          />
        );
      })}
    </Box>
    <Typography variant="body3" sx={styles.barLabel}>
      {bar.label}
    </Typography>
  </Box>
);
export default StackedBar;
